import { Router } from './lib/routing/Router';
import { TanstackQueryProvider } from './lib/common/data/TanstackQueryProvider';
import './styles/global-styles.scss';

function App() {

  return (
    <TanstackQueryProvider>
      <Router />
    </TanstackQueryProvider>
  );
}

export default App;
